
import { ImageSources } from '../types/stage-campaign-item.types';
import { defineComponent, PropType } from 'vue';

export default defineComponent({
  name: 'EmhStageCampaignItemImage',
  props: {
    pictureSources: Array as PropType<ImageSources[]>,
    pictureFallbackImgSrc: String,
    pictureDescription: String,
  },
});
